import React, { useCallback, useMemo } from 'react'
import classNames from 'classnames'
import { useDashboard } from '@aytm/app/insights/dashboard/components/hooks'
import './SwapButton.scss'

const CLASS = 'insights-swap-button'

export const SwapButton: React.FC<{
  className?: string
  wait?: boolean
  onClick: (arg: { swap: boolean }) => void
}> = ({ className = '', wait = false, onClick }) => {
  const { blockModel } = useDashboard()
  const swap = useMemo(() => blockModel?.getObject('swap') || false, [blockModel])
  return (
    <div className={`${CLASS}-container`}>
      <i
        className={classNames(CLASS, 'icon-aytmfd-swap', className, {
          [`${CLASS}-wait`]: wait,
          [`${CLASS}-active`]: swap
        })}
        onClick={useCallback(() => {
          !wait && onClick?.({ swap: !swap })
        }, [onClick, swap, wait])}
        title={swap ? 'Swapped' : ''}
      />
    </div>
  )
}
SwapButton.displayName = 'SwapButton'
